import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/api/query-keys";
import { type Assistant, getAssistant } from "../api/getAssistant";
import { suggestStarters } from "../api/suggestStarters";

/** The assistant a new chat is scoped to (null when it's a plain chat). */
export function useChatAssistant(id: string | null) {
  return useQuery({
    queryKey: queryKeys.chat.assistant(id ?? ""),
    queryFn: () => getAssistant(id as string),
    enabled: id !== null,
    staleTime: 2 * 60_000,
  });
}

/**
 * Generated conversation starters for an assistant. Generative + paid, so it's
 * cached for the session (never auto-refetched) and only runs once we have one.
 */
export function useAssistantStarters(assistant: Assistant | undefined) {
  return useQuery({
    queryKey: queryKeys.chat.assistantStarters(assistant?.id ?? ""),
    queryFn: () =>
      suggestStarters({
        name: assistant!.name,
        ...(assistant!.description ? { description: assistant!.description } : {}),
        ...(assistant!.system_prompt ? { system_prompt: assistant!.system_prompt } : {}),
      }),
    enabled: assistant !== undefined,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
